// extracted by mini-css-extract-plugin
module.exports = {"faqContainer":"style-module__faqContainer___1Ie8D"};